import React, { useState, useEffect, useContext } from "react";
import { Container, Grid, Card, Button, Form, Avatar, Profile, Media, Comment, GalleryCard, Icon } from "tabler-react";
import Select from "react-select";
import SiteWrapper from "../SiteWrapper.react";
import { softphoneContext } from "../context/softphoneContext";
import { Crud_Catalogos } from "../herramientas/Crud_Catalogos";
//import temadark from "../../public/images/temadark.jpg";

var temas= [{ value: 0, label: "Selecciona  un tema" }, { value: 1, label: "Defaul" }, { value: 2, label: "Oscuro" }];
var user= JSON.parse(sessionStorage.getItem("usuario"));
var perfil= JSON.parse(sessionStorage.getItem("perfil"));
var currentTema= user ? JSON.parse( localStorage.getItem('skyonetema'+user.id) ): null;
const temaDark= "body { /* sk */ margin: 0; font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; font-size: 0.9375rem; font-weight: 400; line-height: 1.5; color: #79826d; text-align: left; background-color: rgba(58, 66, 59, 0.993); } .modal-content { position: relative; display: -ms-flexbox; display: flex; -ms-flex-direction: column; flex-direction: column; width: 100%; pointer-events: auto; background-color: rgba(96, 109, 98, 0.932); /* sk */ background-clip: padding-box; border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 3px; outline: 0; }.blockquote-footer {display: block;font-size: 80%;color: #868e96;/* sk */}.table th,.text-wrap table th,.table td,.text-wrap table td {padding: 0.75rem;vertical-align: top;border-top: 1px solid #e2e6de3a; /* sk */}.table-success,.table-success > th,.table-success > td {background-color: #d2ecb8; /* sk */}.table-hover .table-success:hover {background-color: #c5e7a4; /* sk */}.table-hover .table-success:hover > td,.table-hover .table-success:hover > th {background-color: #c5e7a4; /* sk */}.valid-feedback {display: none;width: 100%;margin-top: 0.25rem;font-size: 87.5%;color: #5eba00; /* sk */}.btn-primary { /* sk */color: #fff;background-color: #638069;border-color: #6b806f;}.btn-primary:hover { /* sk */color: #fff;background-color: #465849;border-color: #638069;}.dropdown-item:hover,.dropdown-item:focus {color: #16181b;text-decoration: none;background-color: rgba(238, 247, 213, 0.514); /* sk */}.dropdown-item.active,.dropdown-item:active {color: #fff;text-decoration: none;background-color: rgba(107, 139, 114, 0.993); /* sk */}.dropdown-item.disabled,.dropdown-item:disabled {color: #868e96; /* sk */background-color: transparent;}.nav-tabs .nav-link.active,.nav-tabs .nav-item.show .nav-link { /* sk */color: #77887b;background-color: rgba(36, 48, 39, 0.979);border-color: #77887b #77887b #91a595;}.card-header {padding: 1.5rem 1.5rem;margin-bottom: 0;background-color: rgba(49, 66, 58, 0.836); /* sk */border-bottom: 1px solid rgba(0, 40, 100, 0.12);}.card {  position: relative;  display: -ms-flexbox;  display: flex;  -ms-flex-direction: column;  flex-direction: column;  min-width: 0;  word-wrap: break-word;  background-color: rgba(20, 23, 18, 0.949);  background-clip: border-box;  border: 1px solid rgba(0, 100, 33, 0.12);  border-radius: 3px;}.header {  padding-top: 0.75rem;  padding-bottom: 0.75rem;  background: rgba(22, 26, 23, 0.993);  border-bottom: 1px solid rgba(0, 40, 100, 0.12);}.footer {  background: rgba(22, 26, 23, 0.993);  border-top: 1px solid rgba(0, 40, 100, 0.12);  font-size: 0.875rem;  padding: 1.25rem 0;  color: #b9c0cf;}.form-control {  display: block;  width: 100%;  padding: 0.375rem 0.75rem;  font-size: 0.9375rem;  line-height: 1.6;  color: #495057;  background-color: rgba(50, 67, 59, 0.84);  background-clip: padding-box;  border: 1px solid rgba(0, 40, 100, 0.12);  border-radius: 3px;  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;}.css-yk16xz-control {    background-color: rgba(50, 67, 59, 0.84);}.form-control:disabled,.form-control[readonly] {  background-color: rgba(50, 67, 59, 0.84);  opacity: 1;}.custom-switch-indicator {  display: inline-block;  height: 1.25rem;  width: 2.25rem;  background: rgba(0, 0, 0, 0.45);  border-radius: 50px;  position: relative;  vertical-align: bottom;  border: 1px solid rgba(0, 40, 100, 0.95);  transition: 0.3s border-color, 0.3s background-color;}.dropdown-menu {  position: absolute;  top: 100%;  left: 0;  z-index: 1000;  display: none;  float: left;  min-width: 10rem;  padding: 0.5rem 0;  margin: 0.125rem 0 0;  font-size: 0.9375rem;  color: #495057;  text-align: left;  list-style: none;  background-color: rgba(0, 0, 0, 0.98);  background-clip: padding-box;  border: 1px solid rgba(0, 40, 100, 0.12);  border-radius: 3px;}";
const ProfilePage =()=>{
  const softphone = useContext(softphoneContext);
  const [tema, setTema] = useState({ value: 0, label: "Selecciona una opción" });
  const [troncal, setTroncal] = useState({});
  useEffect(() => {
    if(currentTema){
      if( currentTema.value){
        for(let item of temas){
          if( item.value == currentTema.value){
            setTema(item);
            break;
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if( softphone.getValues().grupo ){
      getfuntion("get", "", "", "softphone_configuracion/grupo/" + softphone.getValues().grupo, "softphonePlataforma");
    }    
  }, [softphone]);

  const getfuntion = ( metodo = "get", obj = [], id = "",  catalogo = "", stateVar = "") => {
    return Crud_Catalogos( catalogo, "usuario", metodo, id, obj, "", stateVar )
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if( stateVar === "softphonePlataforma"){
              setTroncal(returnVal);
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveTema=() => {
    switch(tema.value){
      case 1:{
        localStorage.setItem('skyonetema'+user.id, JSON.stringify({ value: 1, tema: '' }) );
        window.location.href= "/perfilusuario";
        break;
      }
      case 2:{
        localStorage.setItem('skyonetema'+user.id, JSON.stringify({ value: 2, tema: temaDark }) );
        window.location.href= "/perfilusuario";
        break;
      }
      default:
        break;
    }
    //localStorage.getItem('skytemas')? require ("./Temas/Tabler.css"): require ("tabler-react/dist/Tabler.css");
    //localStorage.setItem('skytema', 'dark');
  }
  return (
    <SiteWrapper>
      <div className="my-3 my-md-5">
        <Container>
          <Grid.Row>
            <Grid.Col lg={4}>
            <Card>
              <Card.Body>
                <Media>
                  <Avatar
                    size="xxl"
                    className="mr-5"
                    imageURL="./user/user.png"
                  />
                  <Media.BodySocial
                    name={user.persona.aPaterno+" "+ user.persona.aMaterno+" "+user.persona.nombre}
                    workTitle={ perfil.nombre }
                    //facebook="Facebook"
                    //twitter="Twitter"
                    phone={"762"}
                    //skype="@skypename"
                  />
                </Media>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body>
                <ul className="list-group">
                  <li className="list-group-item disabled">
                    <i className="fa fa-envelope">
                      <span Nameclass="badge"> { user.persona.correo }</span>
                    </i>
                  </li>
                  <li className="list-group-item">
                    <i className="fa fa-address-book-o">
                      <span Nameclass="badge"> { user.persona.skyangel? "Interno": "Externo" } </span>
                    </i>
                  </li>
                  <li className="list-group-item">
                    <i className="fa fa-phone">
                      <span Nameclass="badge"> { user.persona.telefono } </span>
                    </i>
                  </li>
                </ul>
                <hr/>
                <h4>Webphone</h4>
                { softphone.getValues().id?
                  <ul className="list-group">
                    <li className="list-group-item disabled">
                      <i className="fa fa-group">
                        <span Nameclass="badge"> { troncal.caller_id? troncal.caller_id : "" }</span>
                      </i>
                    </li>
                    <li className="list-group-item">
                      <i className="fa fa-hashtag">
                        <span Nameclass="badge"> { softphone.getValues().extension } </span>
                      </i>
                    </li>
                    <li className="list-group-item">
                      <i className="fa fa-user">
                        <span Nameclass="badge"> { softphone.getValues().username } </span>
                      </i>
                    </li>
                    <li className="list-group-item">
                      <i className="fa fa-pause-circle">
                        <span Nameclass="badge"> { softphone.getValues().pausaEstatus ? softphone.getValues().pausaMotivo: "Disponible" } </span>
                      </i>
                    </li>
                  </ul>
                  : null
                }
              </Card.Body>
            </Card>
            </Grid.Col>
            <Grid.Col lg={8}>
              <Card>
                <Card.Header>
                  Configuración
                  <Card.Options>
                    <Button target="_blank" size="sm" RootComponent="a" color="primary"
                            onClick= { () => saveTema() }
                            disabled={ !tema.value }
                            icon={"save"}
                    >
                    </Button>
                  </Card.Options>
                </Card.Header>
                <Card.Body>
                  <Form.Group label="Corredores">
                    <Select value={ tema } onChange={(e)=> setTema(e) } options={ temas } />
                  </Form.Group>
                  {tema.value === 1
                  ? <GalleryCard.Image
                      src={ "images/temadefault.jpg" }
                    />
                  : tema.value === 2
                      ?<GalleryCard.Image
                        src={ "images/temadark.jpg" }
                      />
                      :null
                  }
                </Card.Body>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Container>
      </div>
    </SiteWrapper>
  );
}

export default ProfilePage;
